/**
 * The Performance Cockpit mark: a cockpit's attitude indicator with a rising
 * horizon (solid ground, so it reads at header and favicon size). It takes
 * the text colour (on the header: the organization's on-header colour);
 * public/favicon.svg is the same mark on the brand blue.
 */
export function CockpitMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true" focusable="false">
      <circle cx="16" cy="16" r="12.2" fill="none" stroke="currentColor" strokeWidth="2.8" />
      <path d="M7.2 19.85L25.6 15.98A9.6 9.6 0 0 1 7.2 19.85Z" fill="currentColor" />
      <path
        d="M8.6 13.6H13.2M18.8 13.6H23.4M16 5.4V7.8"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      <circle cx="16" cy="13.6" r="2.2" fill="currentColor" />
    </svg>
  );
}
